module.exports = [{
      plugin: require('C:/Users/djorna.Pokedex/Documents/Juggl/Website/blog/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":590},
    },{
      plugin: require('C:/Users/djorna.Pokedex/Documents/Juggl/Website/blog/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/djorna.Pokedex/Documents/Juggl/Website/blog/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/djorna.Pokedex/Documents/Juggl/Website/blog/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('C:/Users/djorna.Pokedex/Documents/Juggl/Website/blog/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
